/**
 * en-GB messages added by Phase 3 task W22 (docs/PHASE-3-PLAN.md). Only that task edits this file.
 * Flat keys, `{name}` placeholders, merged into enGB by ./index.ts.
 */
export const w22EnGB = {
    // The display app (/display), a full-screen TV page
    'displayUi.pair.title': 'Set up this screen',
    'displayUi.pair.instruction': 'Enter this code in CloudSign: Manage -> Reception displays',
    'displayUi.pair.codeLabel': 'Pairing code {code}',
    'displayUi.pair.waiting': 'Waiting for the code to be entered',
    'displayUi.pair.expired': 'That code ran out of time. A new one is on its way.',
    'displayUi.pair.retrying': 'Cannot reach CloudSign. Trying again.',
    'displayUi.view.loading': 'Loading',
    'displayUi.view.offline': 'Cannot reach CloudSign. Showing the last information we have.',
    'displayUi.view.logoAlt': 'Logo',
    'displayUi.view.clock': 'Time',
    'displayUi.welcome.title': 'Welcome',
    'displayUi.welcome.person': 'Welcome, {name}',
    'displayUi.welcome.personCompany': 'Welcome, {name} ({company})',
    'displayUi.welcome.more': '+{count} more',
    'displayUi.welcome.none': 'No visitors are expected just now.',
    'displayUi.headcount.title': 'In the building',
    'displayUi.headcount.value': '{count} people',
    'displayUi.headcount.one': '1 person',
    'displayUi.capacity.title': 'Capacity',
    'displayUi.capacity.level.none': 'No limit set',
    'displayUi.capacity.level.green': 'Plenty of space',
    'displayUi.capacity.level.amber': 'Getting busy',
    'displayUi.capacity.level.red': 'At capacity',
    'displayUi.capacity.of': '{count} of {capacity}',
    'displayUi.notices.title': 'Notices',
    'displayUi.qr.title': 'Sign in with your phone',
    'displayUi.qr.description': 'Scan this code with your phone camera.',
    'displayUi.qr.alt': 'QR code for signing in',
    'displayUi.evac.title': 'Evacuate the building',
    'displayUi.evac.drillTitle': 'Fire drill',
    'displayUi.evac.instruction': 'Leave now by the nearest safe exit and go to your muster point.',
    'displayUi.evac.drillInstruction': 'This is a drill. Leave by the nearest safe exit and go to your muster point.',
    'displayUi.evac.points': 'Muster points',
    'displayUi.evac.noPoints': 'Follow the signs to the assembly point.',
    // Portal: Manage -> Reception displays
    'displayUi.manage.title': 'Reception displays',
    'displayUi.manage.description': 'TV and monitor screens at reception. Each shows who is expected, who is in the building and your notices.',
    'displayUi.manage.add': 'Add a display',
    'displayUi.manage.empty': 'No displays yet. Open the display address on a TV to get a code, then add it here.',
    'displayUi.manage.table': 'Reception displays',
    'displayUi.manage.col.name': 'Name',
    'displayUi.manage.col.site': 'Site',
    'displayUi.manage.col.lastSeen': 'Last seen',
    'displayUi.manage.col.status': 'Status',
    'displayUi.manage.neverSeen': 'Never',
    'displayUi.manage.status.active': 'Active',
    'displayUi.manage.status.revoked': 'Unpaired',
    'displayUi.manage.edit': 'Settings for {name}',
    'displayUi.manage.unpair': 'Unpair {name}',
    'displayUi.manage.unpaired': '{name} unpaired.',
    'displayUi.manage.filterSite': 'Site',
    'displayUi.manage.allSites': 'All sites',
    'displayUi.add.title': 'Add a display',
    'displayUi.add.description': 'Open the display address on the screen. It shows a 9-digit code. Type it here.',
    'displayUi.add.code': 'Code shown on the screen',
    'displayUi.add.codeHint': '9 digits',
    'displayUi.add.site': 'Site',
    'displayUi.add.name': 'Name for this screen',
    'displayUi.add.submit': 'Add display',
    'displayUi.add.done': '{name} added.',
    'displayUi.settings.title': 'What {name} shows',
    'displayUi.settings.welcome': 'Show expected visitors',
    'displayUi.settings.window': 'Show visitors expected in the next (minutes)',
    'displayUi.settings.names': 'Names on the welcome list',
    'displayUi.settings.names.first_name': 'First name only',
    'displayUi.settings.names.first_name_company': 'First name and company',
    'displayUi.settings.names.none': 'No names',
    'displayUi.settings.headcount': 'Show how many people are in the building',
    'displayUi.settings.capacity': 'Show the capacity bar',
    'displayUi.settings.notices': 'Show notices',
    'displayUi.settings.clock': 'Show the clock',
    'displayUi.settings.message': 'Message for the screen (optional)',
    'displayUi.settings.messageHint': 'Shown across the top of the screen. Up to 300 characters.',
    'displayUi.settings.save': 'Save changes',
    'displayUi.settings.saved': 'Display settings saved.',
    'displayUi.settings.close': 'Close',
    'displayUi.settings.siteDefaults': 'The defaults for new screens at a site are on the site page, under Reception display.',
};
//# sourceMappingURL=w22.js.map